import { Box } from '@frontierag/frontier-ui-library';
import { useApp } from 'contexts/App';
import { AccountRepresentativesField } from 'fields';
import { useField } from 'formik';

import Customers from './Customers';
import MultiAccount from './MultiAccount';
import Notes from './Notes';
import OfficeLocation from './OfficeLocation';

export default function CustomerDetails() {
  const {
    state: { isGroupUser },
  } = useApp();

  const [{ value: customerReference }] = useField('customer.customerReference');

  return (
    <Box sx={{ display: 'grid', rowGap: 3 }}>
      <Customers name="customer" />
      {customerReference && <MultiAccount customerReference={customerReference} />}
      {!isGroupUser && (
        <AccountRepresentativesField name="representative" textFieldProps={{ required: true }} />
      )}
      <OfficeLocation />
      <Notes />
    </Box>
  );
}
